import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppVentaRegistro = Loadable(lazy(() => import('./view/VentaRegistro')))
const AppVentaGestion = Loadable(lazy(() => import('./view/VentaGestion')))

export const ventasRoutesMap = {
  registro: {
    name: 'Registrar Alquiler',
    path: '/ventas/registro',
  },
  gestion: {
    name: 'Gestión de Alquileres',
    path: '/ventas/gestion',
  },
}

const ventasRoutes = [
  {
    path: ventasRoutesMap.registro.path,
    element: <AppVentaRegistro />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.gestion.path,
    element: <AppVentaGestion />,
    auth: authRoles.admin,
  },
]

export default ventasRoutes
